function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChairHjerte = function SvgChairHjerte(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79 88"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1630.98 232v36h-10.71v-9.333h5.36V236h-5.36v-14.667H1635V232zm-13.39 0v4h-44.18v-17.333h-8.04v-33.334a5.347 5.347 0 0 1 5.36-5.333h49.54a5.347 5.347 0 0 1 5.36 5.333v33.334h-8.04zm-22.6-32.976c-3.36-7.975-12.93-6.114-12.99 3.142-.04 5.084 4.55 6.984 7.61 9.017 2.96 1.971 5.07 4.667 5.4 5.815.29-1.125 2.64-3.9 5.38-5.87 3-2.158 7.65-3.933 7.61-9.017-.06-9.279-9.8-10.744-13.01-3.087m-26.94 39.643h54.9V256h-54.9zm2.68-2.667h-5.36v22.667h5.36V268h-10.71v-36H1556v-10.667h14.73z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    transform: "translate(-1556 -180)"
  }));
};
export default SvgChairHjerte;